export default __webpack_public_path__ + "static/media/cKfDKjeU.01462da3.svg";